import _get from 'lodash/get';
import { FilterGroupingEnum, AssetFilterInputObject } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import { FieldNames } from '../enums';

interface OptionItem {
  value: string;
  label: string;
  [key: string]: unknown;
}

export function createAdditionalFilters(
  filterValues: Values,
): AssetFilterInputObject[] {
  const filters: AssetFilterInputObject[] = [];

  // Process Sectors filter
  const sectors = _get(filterValues, FieldNames.Sectors, []) as OptionItem[];
  if (sectors && sectors.length > 0) {
    const sectorIds = sectors.map((sector) => sector.value);
    filters.push({
      siteSectorId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: sectorIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  // Process Site filter
  const sites = _get(filterValues, FieldNames.Sites, []) as OptionItem[];
  if (sites && sites.length > 0) {
    const siteIds = sites.map((site) => site.value);
    filters.push({
      siteId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  // Process Asset category filter
  const categories = _get(
    filterValues,
    FieldNames.Categories,
    [],
  ) as OptionItem[];
  if (categories && categories.length > 0) {
    const categoryIds = categories.map((category) => category.value);
    filters.push({
      categoryId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: categoryIds },
        filterGroup: 'additionalFilters',
      },
    });
  }

  return filters;
}
